module.exports = __webpack_public_path__ + "static/media/Roboto-Regular.3e1af3ef.ttf";